/*
 * Heldenglueck B2B - Produktseite: Artikelnummer/EAN und Serienliste. 03.09.2026, Fassung 3
 *
 * 1. Artikelnummer und EAN ueber dem Mengenblock. Die Theme-eigene SKU-Zeile
 *    ueber dem Titel wird ausgeblendet, damit sie nicht doppelt steht.
 * 2. "Weitere Motive": Kartenraster mit Mengenwahl je Karte und
 *    Sammel-Hinzufuegen. Nur fuer eingeloggte Haendler, weil Preise drinstehen.
 */

(function () {
  var VE_RULES = [
    { tag: 'VE-4', step: 4 },
    { tag: 'VE-10', step: 10 },
    { tag: 'VE-12', step: 12 },
    { tag: 'VE-24', step: 24 }
  ]

  var SERIEN = [
    'kerzen', 'tassen', 'postkarten', 'klappkarten', 'poster', 'notizblocke', 'kalender',
    'aufkleber', 'bleistifte', 'servietten', 'magnete', 'kornerkissen', 'geschenkanhanger',
    'tee', 'tee-probierglaser', 'geschirrtucher', 'fussmatten', 'geschenkboxen', 'dosen', 'kleidung'
  ]

  var MAX_KARTEN = 24
  var STUECK = 'St\u00fcck'

  function kunde() {
    return window.hgKunde === true
  }

  function euro(cents) {
    var betrag = (cents / 100).toFixed(2)
    var teile = betrag.split('.')
    teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return teile.join(',') + '\u00a0\u20ac'
  }

  function regelAusTags(tags) {
    if (!tags) return null
    for (var i = 0; i < VE_RULES.length; i++) {
      if (tags.indexOf(VE_RULES[i].tag) !== -1) return VE_RULES[i]
    }
    return null
  }

  function css() {
    if (document.getElementById('hg-produktseite-css')) return
    var style = document.createElement('style')
    style.id = 'hg-produktseite-css'
    style.textContent =
      '.hg-artikel{margin:0 0 .9rem;font-size:.85em;opacity:.65;display:flex;flex-wrap:wrap;gap:.4rem 1.2rem;}' +
      '.hg-serie{max-width:1200px;margin:3.5rem auto 2rem;padding:0 20px;box-sizing:border-box;}' +
      '.hg-serie__kopf{display:flex;justify-content:space-between;align-items:baseline;gap:1rem;margin:0 0 1.4rem;padding-bottom:.8rem;border-bottom:1px solid rgba(0,0,0,.1);}' +
      '.hg-serie__titel{font-size:1.35em;font-weight:600;margin:0;letter-spacing:-.01em;}' +
      '.hg-serie__unter{display:block;font-size:.72em;font-weight:400;opacity:.6;margin-top:.25rem;}' +
      '.hg-serie__link{font-size:.9em;opacity:.7;text-decoration:underline;white-space:nowrap;color:inherit;}' +
      '.hg-serie__raster{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:1.1rem;}' +
      '.hg-serie__karte{display:flex;flex-direction:column;border:1px solid rgba(0,0,0,.1);border-radius:14px;overflow:hidden;background:#fff;transition:border-color .15s,box-shadow .15s;}' +
      '.hg-serie__karte:hover{border-color:rgba(0,0,0,.3);}' +
      '.hg-serie__karte[data-menge]:not([data-menge="0"]){border-color:currentColor;box-shadow:0 0 0 1px currentColor inset;}' +
      '.hg-serie__bildlink{display:block;aspect-ratio:1/1;background:rgba(0,0,0,.04);overflow:hidden;}' +
      '.hg-serie__bild{width:100%;height:100%;object-fit:cover;display:block;transition:transform .3s;}' +
      '.hg-serie__karte:hover .hg-serie__bild{transform:scale(1.03);}' +
      '.hg-serie__body{padding:.9rem .9rem .5rem;flex:1 1 auto;}' +
      '.hg-serie__name{font-weight:500;line-height:1.3;margin:0 0 .3rem;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}' +
      '.hg-serie__name a{color:inherit;text-decoration:none;}' +
      '.hg-serie__meta{font-size:.85em;opacity:.65;}' +
      '.hg-serie__preisbetrag{font-size:.9em;margin-top:.35rem;min-height:1.2em;font-weight:600;}' +
      '.hg-serie__stepper{display:flex;align-items:stretch;margin:.4rem .9rem .9rem;border:1px solid rgba(0,0,0,.18);border-radius:8px;overflow:hidden;}' +
      '.hg-serie__btn{flex:0 0 2.6rem;border:0;background:transparent;color:inherit;font:inherit;font-size:1.2em;cursor:pointer;line-height:1;}' +
      '.hg-serie__btn:hover{background:rgba(0,0,0,.05);}' +
      '.hg-serie__btn:disabled{opacity:.3;cursor:not-allowed;}' +
      '.hg-serie__input{flex:1 1 auto;min-width:0;width:100%;border:0;border-left:1px solid rgba(0,0,0,.18);border-right:1px solid rgba(0,0,0,.18);background:transparent;color:inherit;font:inherit;text-align:center;padding:.55rem .2rem;-moz-appearance:textfield;}' +
      '.hg-serie__input::-webkit-outer-spin-button,.hg-serie__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}' +
      '.hg-serie__fuss{position:sticky;bottom:0;z-index:5;display:flex;justify-content:space-between;align-items:center;gap:1rem;flex-wrap:wrap;margin:1.4rem 0 0;padding:1rem 1.2rem;border:1px solid rgba(0,0,0,.1);border-radius:14px;background:#fff;box-shadow:0 -6px 24px rgba(0,0,0,.06);}' +
      '.hg-serie__summe{font-size:1em;}' +
      '.hg-serie__summe strong{font-weight:600;}' +
      '.hg-serie__summe small{display:block;font-size:.82em;opacity:.6;margin-top:.15rem;}' +
      '.hg-serie__add{min-width:16rem;}' +
      '.hg-serie__add:disabled{opacity:.4;cursor:not-allowed;}' +
      '.hg-serie__status{font-size:.9em;margin:.8rem 0 0;min-height:1.2em;}' +
      '@media (max-width:640px){.hg-serie{padding:0 14px;margin-top:2.5rem;}.hg-serie__raster{grid-template-columns:repeat(2,1fr);gap:.7rem;}.hg-serie__body{padding:.7rem .7rem .4rem;}.hg-serie__stepper{margin:.3rem .7rem .7rem;}.hg-serie__btn{flex-basis:2.2rem;}.hg-serie__fuss{flex-direction:column;align-items:stretch;text-align:center;}.hg-serie__add{min-width:0;width:100%;}}'
    document.head.appendChild(style)
  }

  /* ---------- Artikelnummer und EAN ---------- */

  function aktuelleDaten() {
    var form = document.querySelector('form[action*="/cart/add"]')
    var feld = form ? form.querySelector('[name="id"]') : null
    var id = feld ? feld.value : null
    var daten = window.hgBestaende && id ? window.hgBestaende[id] : null
    if (!daten && window.hgBestaende) {
      var erste = Object.keys(window.hgBestaende)[0]
      daten = erste ? window.hgBestaende[erste] : null
    }
    return daten
  }

  function themeSkuAusblenden(sku) {
    if (!sku) return
    var h1 = document.querySelector('h1')
    if (!h1) return

    var kandidaten = document.querySelectorAll('p, span, div')
    Array.prototype.forEach.call(kandidaten, function (el) {
      if (el.closest('.hg-artikel') || el.closest('.hg-serie')) return
      if (el.children.length > 1) return
      var text = (el.textContent || '').trim()
      if (text !== sku) return
      var pos = h1.compareDocumentPosition(el)
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) el.style.display = 'none'
    })
  }

  function artikelnummer() {
    var form = document.querySelector('form[action*="/cart/add"]')
    if (!form || form.dataset.hgArtikel === '1') return

    var daten = aktuelleDaten()
    if (!daten) return

    form.dataset.hgArtikel = '1'

    var sku = daten.sku || ''
    var ean = daten.ean || ''

    themeSkuAusblenden(sku)

    var zeile = document.createElement('div')
    zeile.className = 'hg-artikel'

    if (sku && ean && sku === ean) {
      zeile.innerHTML = '<span>Art.-Nr. / EAN ' + sku + '</span>'
    } else {
      if (sku) zeile.innerHTML += '<span>Art.-Nr. ' + sku + '</span>'
      if (ean) zeile.innerHTML += '<span>EAN ' + ean + '</span>'
    }

    if (!zeile.innerHTML) return

    var ziel = form.querySelector('.hg-menge')
    if (ziel) {
      ziel.parentElement.insertBefore(zeile, ziel)
    } else {
      var knopf = form.querySelector('[name="add"], button[type="submit"]')
      if (knopf && knopf.parentElement) knopf.parentElement.insertBefore(zeile, knopf)
    }
  }

  /* ---------- Serie ---------- */

  var serie = null
  var auswahl = {}

  function serieFinden() {
    if (!window.hgProdukt || !window.hgProdukt.kategorien) return null
    var k = window.hgProdukt.kategorien
    for (var i = 0; i < k.length; i++) {
      if (SERIEN.indexOf(k[i].handle) !== -1) return k[i]
    }
    return null
  }

  function summeAktualisieren(box) {
    var positionen = 0
    var stueck = 0
    var betrag = 0

    Object.keys(auswahl).forEach(function (id) {
      var a = auswahl[id]
      if (a.menge > 0) {
        positionen++
        stueck += a.menge
        betrag += a.menge * a.preis
      }
    })

    var summe = box.querySelector('.hg-serie__summe')
    var knopf = box.querySelector('.hg-serie__add')

    if (positionen === 0) {
      summe.innerHTML = 'Noch nichts ausgew\u00e4hlt<small>Mengen an den Motiven w\u00e4hlen, dann alles auf einmal in den Warenkorb.</small>'
      knopf.disabled = true
    } else {
      summe.innerHTML = '<strong>' + euro(betrag) + '</strong> netto<small>' + positionen + (positionen === 1 ? ' Motiv' : ' Motive') + ' \u00b7 ' + stueck + '\u00a0' + STUECK + '</small>'
      knopf.disabled = false
    }
  }

  function mengeSetzen(box, karte, menge, richtung) {
    var id = karte.dataset.variante
    var a = auswahl[id]
    var step = a.step

    if (menge <= 0) {
      menge = 0
    } else {
      var faktor = richtung < 0 ? Math.floor(menge / step) : Math.ceil(menge / step)
      menge = Math.max(step, faktor * step)
    }

    a.menge = menge
    karte.dataset.menge = menge
    karte.querySelector('.hg-serie__input').value = menge
    karte.querySelector('[data-richtung="-1"]').disabled = menge === 0
    karte.querySelector('.hg-serie__preisbetrag').textContent = menge > 0 ? euro(menge * a.preis) : ''

    summeAktualisieren(box)
  }

  function karteBauen(box, produkt) {
    var variante = null
    for (var i = 0; i < produkt.variants.length; i++) {
      if (produkt.variants[i].available) {
        variante = produkt.variants[i]
        break
      }
    }
    if (!variante) return null

    var regel = regelAusTags(produkt.tags)
    var step = regel ? regel.step : 1
    var preis = Math.round(parseFloat(variante.price) * 100)
    var bild = produkt.images && produkt.images.length ? produkt.images[0].src : ''

    if (bild) bild = bild.replace(/(\.[a-z]+)(\?.*)?$/i, '_480x480_crop_center$1$2')

    auswahl[variante.id] = { menge: 0, step: step, preis: preis }

    var karte = document.createElement('div')
    karte.className = 'hg-serie__karte'
    karte.dataset.variante = variante.id
    karte.dataset.menge = 0

    karte.innerHTML =
      '<a class="hg-serie__bildlink" href="/products/' + produkt.handle + '">' +
      (bild ? '<img class="hg-serie__bild" src="' + bild + '" alt="" loading="lazy">' : '') +
      '</a>' +
      '<div class="hg-serie__body">' +
      '<div class="hg-serie__name"><a href="/products/' + produkt.handle + '">' + produkt.title + '</a></div>' +
      '<div class="hg-serie__meta">' + euro(preis) + ' / ' + STUECK + (regel ? ' \u00b7 VE ' + step : '') + '</div>' +
      '<div class="hg-serie__preisbetrag"></div>' +
      '</div>' +
      '<div class="hg-serie__stepper">' +
      '<button type="button" class="hg-serie__btn" data-richtung="-1" disabled aria-label="weniger">\u2212</button>' +
      '<input class="hg-serie__input" type="number" inputmode="numeric" value="0" min="0" step="' + step + '" aria-label="Menge">' +
      '<button type="button" class="hg-serie__btn" data-richtung="1" aria-label="mehr">+</button>' +
      '</div>'

    karte.querySelector('[data-richtung="-1"]').addEventListener('click', function () {
      mengeSetzen(box, karte, auswahl[variante.id].menge - step, -1)
    })
    karte.querySelector('[data-richtung="1"]').addEventListener('click', function () {
      mengeSetzen(box, karte, auswahl[variante.id].menge + step, 1)
    })

    var input = karte.querySelector('.hg-serie__input')
    input.addEventListener('change', function () {
      var wert = parseInt(input.value, 10)
      if (isNaN(wert)) wert = 0
      mengeSetzen(box, karte, wert, wert < auswahl[variante.id].menge ? -1 : 1)
    })
    input.addEventListener('focus', function () {
      input.select()
    })
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault()
        input.blur()
      }
    })

    return karte
  }

  function hinzufuegen(box) {
    var items = []
    Object.keys(auswahl).forEach(function (id) {
      if (auswahl[id].menge > 0) items.push({ id: parseInt(id, 10), quantity: auswahl[id].menge })
    })
    if (!items.length) return

    var knopf = box.querySelector('.hg-serie__add')
    var status = box.querySelector('.hg-serie__status')
    knopf.disabled = true
    status.textContent = 'Wird hinzugef\u00fcgt \u2026'

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (daten) {
          return { ok: r.ok, daten: daten }
        })
      })
      .then(function (ergebnis) {
        if (!ergebnis.ok) {
          status.textContent = ergebnis.daten && ergebnis.daten.description ? ergebnis.daten.description : 'Das hat nicht geklappt. Bitte Mengen pr\u00fcfen.'
          knopf.disabled = false
          return
        }

        status.textContent = items.length + (items.length === 1 ? ' Motiv' : ' Motive') + ' im Warenkorb.'

        Object.keys(auswahl).forEach(function (id) {
          auswahl[id].menge = 0
        })
        Array.prototype.forEach.call(box.querySelectorAll('.hg-serie__karte'), function (karte) {
          karte.dataset.menge = 0
          karte.querySelector('.hg-serie__input').value = 0
          karte.querySelector('[data-richtung="-1"]').disabled = true
          karte.querySelector('.hg-serie__preisbetrag').textContent = ''
        })
        summeAktualisieren(box)

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }))

        var oeffner = document.querySelector('.js-drawer-open-cart, [data-drawer-open="cart"], a[href="/cart"]')
        if (oeffner && window.innerWidth > 640) oeffner.click()
      })
      .catch(function () {
        status.textContent = 'Das hat nicht geklappt. Bitte noch einmal versuchen.'
        knopf.disabled = false
      })
  }

  function serieBauen() {
    if (!kunde()) return
    if (document.querySelector('.hg-serie')) return

    serie = serieFinden()
    if (!serie) return

    var form = document.querySelector('form[action*="/cart/add"]')
    if (!form) return

    var abschnitt = form.closest('.shopify-section') || form.closest('section') || form.parentElement
    if (!abschnitt) return

    var box = document.createElement('section')
    box.className = 'hg-serie'
    box.innerHTML =
      '<div class="hg-serie__kopf"><h2 class="hg-serie__titel">Weitere Motive aus ' + serie.titel +
      '<span class="hg-serie__unter">Mengen direkt w\u00e4hlen und alles zusammen in den Warenkorb legen</span></h2>' +
      '<a class="hg-serie__link" href="/collections/' + serie.handle + '">alle ' + serie.anzahl + ' ansehen</a></div>' +
      '<div class="hg-serie__raster"></div>' +
      '<div class="hg-serie__fuss"><div class="hg-serie__summe"></div>' +
      '<button type="button" class="btn hg-serie__add" disabled>Auswahl in den Warenkorb</button></div>' +
      '<p class="hg-serie__status"></p>'

    abschnitt.insertAdjacentElement('afterend', box)
    summeAktualisieren(box)

    var raster = box.querySelector('.hg-serie__raster')

    fetch('/collections/' + serie.handle + '/products.json?limit=' + (MAX_KARTEN + 1), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null
      })
      .then(function (daten) {
        if (!daten || !daten.products) {
          box.remove()
          return
        }

        var anzahl = 0
        daten.products.forEach(function (p) {
          if (anzahl >= MAX_KARTEN) return
          if (p.id === window.hgProdukt.id) return
          var karte = karteBauen(box, p)
          if (karte) {
            raster.appendChild(karte)
            anzahl++
          }
        })

        if (anzahl === 0) box.remove()
      })
      .catch(function () {
        box.remove()
      })

    box.querySelector('.hg-serie__add').addEventListener('click', function () {
      hinzufuegen(box)
    })
  }

  /* ---------- Start ---------- */

  function start() {
    if (window.location.pathname.indexOf('/products/') === -1) return
    if (!window.hgProdukt) return

    css()
    artikelnummer()
    serieBauen()

    var wartet = false
    var beobachter = new MutationObserver(function () {
      if (wartet) return
      wartet = true
      window.requestAnimationFrame(function () {
        wartet = false
        artikelnummer()
      })
    })
    if (document.body) beobachter.observe(document.body, { childList: true, subtree: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
